<template>
    <div id="press_releasess" >
      <div class="s-card  pressCard  position-relative " >
        <div class="inner s-cont flex-start-center main card-background" :style="{ 'background-image': 'url( ' + item.icon + ')'}">
          <div class="black-gradient-1-bottom w-100 h-100 d-flex align-items-center radius-30">
            <div class="w-100 ">
              <div :class="[lang === 'ar' ? 'text-right' : '' ,'card-title p-0']">
                {{item.title}}
              </div>
              <div :class="[lang === 'ar' ? 'text-right' : '' ,'white-description clamp-2']">
                {{item.description}}
              </div>
              <div :class="[lang === 'ar' ? 'text-right' : '' ,'mt-4', 'read-cont']">
                <div :class="[lang === 'ar' ? 'flex-row-reverse float-right' : '', 'd-flex small-container']">
                  <router-link :to="`/news-details/${cardType}/${item.id}`">
                    <a class="d-flex" :class="[lang === 'ar' ? 'arDir' : '']">
                      <div :class="[lang === 'ar' ? 'ml-2' : 'mr-2' ,'read-text']">
                        <span class="read-text">{{$t('readMore')}}</span>
                      </div>
                      <div>
                        <img class="read-arrow" src="../../assets/icons/readmore.svg">
                      </div>
                    </a>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'PressReleasessCard',
  props: {
    data: {
      type: Object
    },
    show: Boolean,
    cardType: String
  },
  data () {
    return {
      item: { },
      lang: this.$lang
      // cardType: 'news'
    }
  },
  watch: {
    show (val) {
      this.item = this.data
      this.$forceUpdate()
    }
  },
  created () {
    this.item = this.data
  },
  mounted () {
    setTimeout(() => {
      this.$lang === 'ar' ? $('.read-text').css('font-family', 'Mtn-arabic-bold') : $('.read-text').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.card-title').css('font-family', 'Mtn-arabic-bold') : $('.card-title').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.white-description').css('font-family', 'Mtn-arabic-regular') : $('.white-description').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('#random_cards .row.row-padding').css('flex-direction', 'row-reverse') : $('#random_cards .row.row-padding').css('flex-direction', 'row')
      this.$lang === 'ar' ? $('.read-arrow').css('transform', 'rotate(180deg)') : $('.read-arrow').css('transform', 'rotate(0deg)')
    })
    this.arabic()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        $('#random_cards .inner').css('direction', 'rtl')
        $('.small-container').css('direction', 'ltr')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
.read-cont {
  padding: 0px 20px;
}
.arDir {
  direction: rtl;
}
.s-card .card-background {
  background-size: cover !important;
  background-position: center !important;
}
.card-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3!important;
}
.small-container {
  width: max-content;
}
.white-description {
  margin-top: 1rem
}
.white-description {
  display: none;
  overflow: hidden;
  text-overflow: ellipsis;
  /*height: 180px;*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  white-space: pre-wrap;
  padding: 0px 20px !important;
  text-align: start;
}
.main {
  //height: 600px !important;
  //margin: 0 5vw !important;
  border-radius: 30px !important;
  background-size: cover !important;
}
.s-card:hover .white-description {
  display: -webkit-box !important;
  transition: all .4s;
}
.s-card:hover .card-title {
  transform: translateY(-5px);
  transition: all .4s;
}
.card-title {
  transform: translateY(5px);
  transition: all .4s;
  max-width: 484px;
  //max-width: 100%
  font-size: 15px;
  color: #FFCB05;
  padding: 0px 20px !important;
  text-align: start;
}

@media screen and (max-width: 768px) {
  .main {
    //height: 400px !important;
  }
}
.row-padding {
  padding: 2rem 2.5rem 3rem 2.5rem;
}
  .pressCard{
    //width: 400px;
  }
  #press_releasess{
    padding-top: 2rem;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
@media screen and (max-width: 700px) {
  .pressCard{
    //width: 390px;
  }
  .read-cont {
    padding: 0px 20px;
  }
}
@media screen and (max-width: 650px) {
  .pressCard{
    //width: 375px;
  }
}
@media screen and (max-width: 550px) {
  .pressCard{
    //width: 370px;
  }
}
@media screen and (max-width: 530px) {
  .pressCard{
    //width: 360px;
  }
}
@media screen and (max-width: 495px) {
  .pressCard{
    //width: 350px;
  }
}
@media screen and (max-width: 470px) {
  .pressCard{
    //width: 400px;
  }
}
@media screen and (max-width: 480px) {
  #press_releasess{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
  #press_releasess .swiper-wrapper{
    min-height: 500px !important;
  }
</style>
